import { DirectusAnchor } from 'config';
import { AnchorProps } from '../../..';

export const mapDirectusAnchor = ({ anchor, top }: DirectusAnchor): AnchorProps => {
  return {
    anchor,
    top: top ? parseInt(`${top}`, 10) : top,
  };
};
